import React from 'react';
import styled from 'styled-components';
import { FaInstagram } from 'react-icons/fa';

const FooterContainer = styled.footer`
    background-color: transparent;
    padding: 24px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1100px;
    margin: 0 auto;
    width: 100%;

    @media screen and (max-width: 768px) {
        /* Hide footer on mobile IF we are on the home page (detected via prop) */
        ${props => props.isHome && `
            display: none;
        `}
    }
`;

const FooterWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1100px;
    width: 100%;
    margin: 0 auto;
`;

const SocialMedia = styled.section`
    max-width: 1100px;
    width: 100%;
`;

const SocialMediaWrap = styled.div`
    display: flex;
    justify-content: flex-start; /* Align to the left */
    align-items: center;
    max-width: 1100px;
    margin: 20px auto 0 auto;

    @media screen and (max-width: 820px) {
        flex-direction: column;
        margin: 0; 
        align-items: flex-start;
        padding-bottom: max(20px, env(safe-area-inset-bottom)); /* Push up above home bar */
    }
`;

const SocialIcons = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: auto;
`;

const SocialIconLink = styled.a`
    color: #262626;
    font-size: 1rem;
    display: flex;
    align-items: center;
    text-decoration: none;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    margin-bottom: 0; /* Remove bottom margin to save space */
    
    &:hover {
        color: orange;
    }
`;

const Footer = ({ isHome }) => {
    return (
        <FooterContainer isHome={isHome}>
            <FooterWrap>
                <SocialMedia>
                    <SocialMediaWrap>
                        <SocialIcons>
                            <SocialIconLink href="//www.instagram.com/jonathanroot" target="_blank" aria-label="Instagram">
                                @jonathanroot
                            </SocialIconLink>
                        </SocialIcons>
                    </SocialMediaWrap>
                </SocialMedia>
            </FooterWrap>
        </FooterContainer>
    );
};

export default Footer;
